import { IOfferingSKURank } from "../../../../services/api/offering/types";

export const DEFAULT_SKU_RANK: IOfferingSKURank = {
  rank: 0,
};
